import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import InboundPlanAdd from './index.vue';

var InboundPlanPublicPage = function (_super) {
  __extends(InboundPlanPublicPage, _super);

  function InboundPlanPublicPage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  InboundPlanPublicPage = __decorate([Component({
    components: {
      InboundPlanAdd: InboundPlanAdd
    }
  })], InboundPlanPublicPage);
  return InboundPlanPublicPage;
}(Vue);

export default InboundPlanPublicPage;